(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Filter products by URL parameters
  (function() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantOption = urlParams.get('variant_option');
    const variantValue = urlParams.get('variant_value');

    if (variantOption && variantValue) {
      const productCards = document.querySelectorAll('.product-card');

      productCards.forEach(card => {
        const options = JSON.parse(card.dataset.productOptions || '[]');
        let hasMatch = false;

        options.forEach(option => {
          if (option.name.toLowerCase() === variantOption.toLowerCase()) {
            if (option.values.includes(variantValue)) {
              hasMatch = true;
            }
          }
        });

        if (!hasMatch) {
          card.style.display = 'none';
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
